import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Bank from "../../../containers/modules/accounting/bank";

export default function BankRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="bank"
      index
      element={
        <AccessControl
          name={"Bank List"}
          auth={authUser}
          component={() => <Bank />}
        />
      }
    />
  );
}
